import './index.scss';
import React, { useState } from 'react';
import axios from 'axios';
import {
    TemplateIconAudio, TemplateIconDocument, TemplateIconImage, TemplateIconMultipleChoice, TemplateIconText, TemplateIconVideo, IconLessonActive, IconLessonInActive
} from '../../../icons/svgs';
import manager from '../../../Manager';

function ModalActiveLesson({ slides, lessonTitle, setActionLessonActive, isMobileBuilder=false }) {
    const [checkedValue, setCheckedValue] = useState(manager.settings.lessonStatus === "ACTIVE" ? true : false);
    const baseUrl = manager.settings.baseUrl;
    const sessionId = manager.settings.sessionId;
    const lessonId = manager.settings.lessonId;
    const setLessonActivateUrl = baseUrl + '/setLessonActivate';

    const templateIcons = {
        document: <TemplateIconDocument />,
        image: <TemplateIconImage />,
        multiplechoice: <TemplateIconMultipleChoice />,
        text: <TemplateIconText />,
        video: <TemplateIconVideo />,
        audio: <TemplateIconAudio />
    };

    const changeActiveLesson = event => {
        let lessonStatus = event.target.checked ? "ACTIVE" : "INACTIVE";
        setCheckedValue(event.target.checked);
        saveActiveLesson(lessonStatus);
    }

    const saveActiveLesson = async (lessonStatus) => {
        try {
            await axios.post(setLessonActivateUrl, {
                sessionId: sessionId,
                lessonId: lessonId,
                lessonStatus: lessonStatus,
            });
        } catch (error) {
            console.log('Error', error);
        }
    }

    const handleShowModalNewSlide = () => {
        window.jQuery('#tbcourse-modal-new-slide').modal('show');
    }

    const handleBackToCourse = () => {
        var href = window.jQuery('.navbar-brand').attr('href');
        window.location.href = href;
    }

    return (
        <div className={`tbcourse-modal tbcourse-modal-active-lesson modal ${isMobileBuilder ? 'modal-mobile-builder':''}`} id="tbcourse-modal-active-lesson" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title font-size-28">Lesson Activation</h5>
                        <button type="button" className="btn-close" onClick={() => setActionLessonActive(true)} data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-size-14 font-family-inter">
                        <p>You can activate and deactivate lesson based on your teaching needs.</p>
                        <div className="lesson-activated-switch mb-4">
                            <div>
                            {checkedValue ?
                                <div>This lesson contain <span className="font-weight-700"> {slides.length} slides</span> to active</div> :
                                <div>This lesson would be on <span className="font-weight-700">Draft</span> mode</div>
                            }
                            </div>
                            <div className="switch-activated">
                                <div className={`${isMobileBuilder ? 'me-3':'mx-3'} text-header-value`}>
                                    {checkedValue ? <span className='text-success'>Activate</span> : 'Inactive'}
                                </div>
                                <div className="form-check form-switch">
                                    <input className="form-check-input form-activated-lesson" type="checkbox" onChange={changeActiveLesson} checked={checkedValue} id="activatedLesson" />
                                </div>
                            </div>
                        </div>
                        <div className="selecting-lesson-type bg-white rounded-12">
                            <div className={`text-header font-size-18 font-weight-700 text-ellipsis ` + (checkedValue ? 'active' : '')}>
                                {checkedValue ?
                                    <span className="icon-active"><IconLessonActive /></span> :
                                    <span className="icon-inactive"><IconLessonInActive /> </span>
                                }
                                {lessonTitle}
                            </div>
                            <ul className="selection-lesson-items list-unstyled">
                                {slides.map((item, index) => (
                                    <li className="selection-lesson-item" key={index}>
                                        {templateIcons[item.template.iconType()]}
                                        {" "}
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-black font-weight-bold px-4 py-2 font-size-12 px-4 py-2" onClick={() => { handleBackToCourse(); }}>Back to Course</button>
                        <button type="button" className="btn btn-primary font-weight-bold rounded-6 font-size-12 px-4 py-2" onClick={() => { setActionLessonActive(true); handleShowModalNewSlide(); }} data-bs-dismiss="modal">Add More Slide</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalActiveLesson;
